import { Component, OnInit, OnDestroy } from '@angular/core';
import { CSPPerpetualItemsViewModel, CSPDetailsItemViewModel } from '../../../models/csp.model';
import { ManageService } from '../../../services/manage.service';
import { CommonService } from '../../../services';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { MnpIdAipiResponse } from '../../../models/api-response.model';
import { ConfirmMnpidComponent } from '../../../popup-collection/confirm-mnpid/confirm-mnpid.component';
import { MatDialog } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-add-perpetual',
  templateUrl: './add-perpetual.component.html',
  styleUrls: ['./add-perpetual.component.css']
})
export class AddPerpetualComponent implements OnInit, OnDestroy {

  title: string = "Add Perpetual Items";
  searchSoftware: string;
  perpetualMpnIdSelect: string = "";
  cspPerpetualItemsPending: CSPPerpetualItemsViewModel[] = [];
  cspPerpetualItems: CSPPerpetualItemsViewModel[] = [];
  cspPerpetualItemsFilter: CSPPerpetualItemsViewModel[] = [];
  loadContent: boolean = false;
  tenantId: string;
  mpnList: string[];
  setFullWindow:boolean = false;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  checkMpnId: Boolean;
  isCheck: Boolean;
  NoMPNText = '';

  constructor(
    private manageService: ManageService,
    public commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,

  ) {
    this.NoMPNText = commonService.NoMPNText;
   }

  ngOnInit() {
    this.loadContent = false;
    this.checkMpnId = true;
    $('#levelOne').animate({ scrollLeft: $('#managecsp').width() + 505 }, 400);
    
    this.manageService.currentPendingPerpetualItems.pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: CSPPerpetualItemsViewModel[]) => {
      this.cspPerpetualItemsPending = data;
    },
      (error: any) => {
        console.info(error);
        this.loadContent = true;
      });

    this.activatedRoute.parent.url.pipe(takeUntil(this.ngUnsubscribe)).subscribe(url => {
      this.tenantId = url[1].path;
      this.manageService.GetCSPItemsView(this.tenantId).subscribe((res: CSPDetailsItemViewModel) => {
        this.mpnList = res.mpnList;
        if(this.mpnList && this.mpnList.length){
          // this.perpetualMpnIdSelect = this.mpnList[0];
        }
      },
        (error: any) => {
          console.info(error);
          this.loadContent = true;
        });
      this.manageService.GetCSPPerpetualItemList('PERP').subscribe((res: CSPPerpetualItemsViewModel[]) => {
        this.cspPerpetualItems = res;
        this.cspPerpetualItems.forEach(item => {
          item.quantity = "1";
          item.minMaxQtyText = "";
          if (item.minQty) {
            item.minMaxQtyText += "Min Order Qty - " + item.minQty + " ";
          }
          if (item.maxQty) {
            item.minMaxQtyText += "Max Order Qty - " + item.maxQty + " ";
          }
        });
        this.cspPerpetualItemsFilter = this.cspPerpetualItems;
        this.loadContent = true;
      },
        (error: any) => {
          console.info(error);
          this.loadContent = true;
        });
    },
      (error: any) => {
        console.info(error);
        this.loadContent = true;
      });
  }

  AddPerpetualItem(software: CSPPerpetualItemsViewModel): void {
    this.loadContent = false;
    if (!this.cspPerpetualItemsPending.filter(item => item.stockCode == software.stockCode).length) {
      software.totalPrice = this.commonService.toNumber(software.itemPrice.replace('$', '').replace(',', '')) * this.commonService.toNumber(software.quantity);
      software.mpnId = this.perpetualMpnIdSelect;
      this.cspPerpetualItemsPending.push(software);
    } else {
      this.cspPerpetualItemsPending.filter(item => item.stockCode == software.stockCode)[0].mpnId = this.perpetualMpnIdSelect;
      this.cspPerpetualItemsPending.filter(item => item.stockCode == software.stockCode)[0].quantity = (this.commonService.toNumber(this.cspPerpetualItemsPending.filter(item => item.skuId == software.skuId)[0].quantity) + this.commonService.toNumber(software.quantity)).toString();
      this.cspPerpetualItemsPending.filter(item => item.stockCode == software.stockCode)[0].totalPrice = this.commonService.toNumber(software.itemPrice.replace('$', '').replace(',', '')) * this.commonService.toNumber(software.quantity);
    }
    this.loadContent = true;
    // this.commonService.showSuccess("#" + software.stockCode.replace(':', '_'), "New Item added", "right");
    this.commonService.implementToast("New Item added", "Success");
  }

  filterSoftwareItems(): void {
    this.cspPerpetualItemsFilter = this.cspPerpetualItems.filter(cspPerpetualItem => cspPerpetualItem.title.toLowerCase().includes(this.searchSoftware.toLowerCase()) || cspPerpetualItem.stockCode.toLowerCase().includes(this.searchSoftware.toLowerCase()));
  }

  finishAddPerpetual(): void{
    this.manageService.monitorPendingPerpetualItems(this.cspPerpetualItemsPending);
    this.manageService.monitorSelectedTabIndex(2);
    this.manageService.backToTenentPage(this.tenantId);
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  showAutoCompletePanel(trigger: any): void{
    trigger.openPanel();
  }

  confirmMpnID(mpnId: string): void {
    if (mpnId === '' || mpnId === null || mpnId === this.NoMPNText) {
      this.checkMpnId = true;
    } else {
      this.commonService.implementToast('Verifying MPN ID ...', 'Info');
      this.isCheck = true;
      this.manageService.GetPartnerByMPNId(mpnId).subscribe((res: MnpIdAipiResponse) => {
        if (res.result === 'Success') {
          this.manageService.GetMPAStatusByMPNId(mpnId).subscribe((result: MnpIdAipiResponse) => {
            if (result.status === false) {
              this.checkMpnId = result.status;
              this.commonService.implementToast('Verifying Microsoft Partner Agreement Status ...', 'Info');
              const dialogRef = this.dialog.open(ConfirmMnpidComponent, {
                width: '650px',
                panelClass: 'mat-dialog-wrapper'
              });
              this.isCheck = false;
            } else {
              this.checkMpnId = result.status;
              this.isCheck = false;
            }
          });
        } else {
          this.commonService.implementToast(res.info, 'Error');
          this.isCheck = false;
          this.checkMpnId = false;
        }
      },
        (error: any) => {
          console.info(error);
          this.loadContent = true;
        }
      );
    }
  }
  
  close() {
    this.manageService.monitorPendingPerpetualItems(this.cspPerpetualItemsPending);
    this.manageService.monitorSelectedTabIndex(2);
    this.manageService.backToTenentPage(this.tenantId);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
